import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import List, { STATE } from "../../../List/index";
import SecondaryPagination from "../../../SecondaryPagination/SecondaryPagination";
import { TextBox, Button } from "../../..";

import { ReactComponent as AddColorSvg } from "../../../../assets/admin/icons/add-color.svg";
import { ReactComponent as DeleteColorSvg } from "../../../../assets/admin/icons/delete-color.svg";
import { ReactComponent as DeleteDisableSvg } from "../../../../assets/admin/icons/delete-disable.svg";
import { ReactComponent as EyeSvg } from "../../../../assets/admin/icons/eye.svg";

import SearchBox from "../../SearchBox";
import useUsers from "../../../../hooks/useUsers";
import { format } from "date-fns";
import View from "./View";

const columns = [
  {
    display: "#",
    key: "no",
    textAlign: "left",
    maxWidth: 60,
  },
  {
    display: "Name",
    key: "name",
    textAlign: "left",
  },
  {
    display: "Phone no.",
    key: "phone",
    textAlign: "left",
    maxWidth: 120,
  },
  {
    display: "Created on",
    key: "joined",
    textAlign: "left",
    maxWidth: 80,
  },
  {
    display: "Type",
    key: "type",
    textAlign: "left",
    maxWidth: 100,
  },
  {
    display: "",
    key: "status",
    textAlign: "left",
    maxWidth: 100,
  },
  {
    display: "",
    key: "actions",
    textAlign: "left",
    maxWidth: 32,
  },
];

const Company = () => {
  const [dataState, setDataState] = useState(STATE.LOADING);
  const [staffs, setStaffs] = useState(undefined);
  const [metadata, setMetadata] = useState(undefined);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [enableActions, setEnableActions] = useState(false);
  const [selections, setSelections] = useState([]);
  const [summary, setSummary] = useState(undefined);

  // * Toggles
  const [toggleView, setToggleView] = useState(false);
  const [selected, setSelected] = useState(undefined);

  const { queryCompanies, getCompaniesSummary } = useUsers();

  useEffect(() => {
    fetchData();
    return () => {};
  }, []);

  useEffect(() => {
    fetchData();
  }, [filter, limit, page]);

  useEffect(() => {
    setEnableActions(selections.length > 0);
  }, [selections]);

  // * Fetch data
  const fetchData = async () => {
    const _filter = {
      $and: [{ deleted: false }, filter],
    };

    const { data, _metadata } = await queryCompanies(_filter, page, limit);

    const { data: summary } = await getCompaniesSummary();
    setSummary(summary);

    let _staffs = data.map(
      ({ _id, name, phone, createdOn, active, enterprise }, companyIndex) => {
        const _joined = createdOn
          ? format(new Date(createdOn), "dd/MM/yyyy")
          : "-";

        return {
          no: (_metadata.currentPage - 1) * 10 + companyIndex + 1,
          name,
          joined: _joined,
          phone,
          status: (
            <div className="admin-users-item-status">
              <label
                className={`admin-users-item-status__label admin-users-item-status__label--${
                  active ? "active" : "inactive"
                }`}
              >
                {active ? "Active" : "Inactive"}
              </label>
            </div>
          ),
          type: enterprise ? "Enterprise" : "Business",
          actions: (
            <div className="admin-users-item-actions">
              <div
                className="admin-users-item-actions-action"
                onClick={() => handleView(_id)}
              >
                <EyeSvg />
              </div>
            </div>
          ),
        };
      }
    );

    setStaffs(_staffs);
    setMetadata(_metadata);
    setDataState(STATE.IDLE);
  };

  const handleSelected = (row) => {};

  const handleOnAddSelection = (selection) => {
    setSelections((current) => [...current, selection]);
  };

  const handleOnRemoveSelection = (selection) => {
    let _selections = selections.filter((s) => s._id !== selection._id);
    setSelections(_selections);
  };

  const handleOnPageChange = (page) => setPage(page);

  const handleOnLimitChange = (limit) => {
    setPage(1);
    setLimit(limit);
  };

  const handleSearchChange = (value) => {
    if (!value) {
      setFilter({});
      return;
    }

    setPage(1);
    setFilter({
      $or: [
        {
          no: isNaN(value) ? 0 : +value,
        },
        {
          name: { $regex: value },
        },
      ],
    });
  };

  const handleSearch = (values) => {
    const { search } = values;
  };

  const handleAddUser = () => {
    // * handleAddUser
    setSelected(undefined);
    setToggleView(true);
  };

  const handleDeleteUser = () => {
    if (!enableActions) return;
    // * handleDeleteUser
    //!TODO create process delete data
  };

  const handleView = (id) => {
    setSelected(id);
    setToggleView(true);
  };

  const handleViewClose = () => {
    setSelected(undefined);
    setToggleView(false);
  };

  const handleViewSuccess = () => {
    setSelected(undefined);
    setToggleView(false);
    fetchData();
  };

  return (
    <>
      <div className="admin-users">
        {summary && (
          <div className="admin-users-summary">
            <span className="admin-users-summary__title">Summary</span>
            <div className="admin-users-summary__box">
              <div className="admin-users-summary__box__title">Daily</div>
              {summary.daily}
            </div>
            <div className="admin-users-summary__box">
              <div className="admin-users-summary__box__title">Weekly</div>
              {summary.weekly}
            </div>
            <div className="admin-users-summary__box">
              <div className="admin-users-summary__box__title">Monthly</div>
              {summary.monthly}
            </div>
            <div className="admin-users-summary__box">
              <div className="admin-users-summary__box__title">Yearly</div>
              {summary.yearly}
            </div>
          </div>
        )}
        <div className="admin-users-header">
          <SearchBox placeholder="Email or UID" onChange={handleSearchChange} />
          <div className="admin-users-header-actions">
            <div
              className={`admin-users-header-actions-action${
                enableActions
                  ? ""
                  : " admin-users-header-actions-action--disable"
              }`}
              style={{ color: "#F0483E" }}
              onClick={handleDeleteUser}
            ></div>
            <div
              className={`admin-users-header-actions-action`}
              style={{ color: "#0098FF" }}
              onClick={handleAddUser}
            >
              <div className="admin-users-header-actions-action__icon">
                <AddColorSvg />
              </div>
              <div className="admin-users-header-actions-action__text">
                Add company
              </div>
            </div>
          </div>
        </div>
        <List
          contentState={dataState}
          columns={columns}
          dataSource={staffs}
          viewable={false}
          onRecordClick={(e) => handleSelected(e)}
        >
          <SecondaryPagination
            limits={[10, 50]}
            defaultPage={metadata?.currentPage || 1}
            pages={metadata?.totalPages || 1}
            defaultLimit={metadata?.pageSize}
            onPageChange={handleOnPageChange}
            onLimitChange={handleOnLimitChange}
          />
        </List>
      </div>
      {toggleView && (
        <View
          editing={selected}
          onClose={handleViewClose}
          onSuccess={handleViewSuccess}
        />
      )}
    </>
  );
};

Company.propTypes = {};

export default Company;
